import styled from 'styled-components'

export const Area = styled.div`
  margin-top: -8px;
`

export const AddressContainer = styled.div`
  width: 232px;
`
